module.exports = __webpack_public_path__ + "img/12.1.c69e0ac1.jpg";